export default [
  {
    name: 'None',
    value: 'none'
  },
  {
    name: 'Photorealistic',
    value: 'photorealistic',
    imageUrl:
      'https://static.desygner.com/assets/img/ai-style-photorealistic.webp'
  },
  {
    name: '3D',
    value: 'three_dimensional',
    imageUrl:
      'https://static.desygner.com/assets/img/ai-style-3d.webp'
  },
  {
    name: 'Anime',
    value: 'anime',
    imageUrl:
      'https://static.desygner.com/assets/img/ai-style-anime.webp'
  },
  {
    name: 'Illustration',
    value: 'illustration',
    imageUrl:
      'https://static.desygner.com/assets/img/ai-style-illustration.webp'
  },
  {
    name: 'Neon',
    value: 'neon',
    imageUrl:
      'https://static.desygner.com/assets/img/ai-style-neon.webp'
  },
  {
    name: 'Cartoon',
    value: 'cartoon',
    imageUrl:
      'https://static.desygner.com/assets/img/ai-style-cartoon.webp'
  },
  {
    name: 'Pop Art',
    value: 'pop_art',
    imageUrl:
      'https://static.desygner.com/assets/img/ai-style-pop_art.webp'
  },
  {
    name: 'Street Art',
    value: 'street_art',
    imageUrl:
      'https://static.desygner.com/assets/img/ai-style-street_art.webp'
  },
  {
    name: 'Splatter Paint',
    value: 'splatter_paint',
    imageUrl:
      'https://static.desygner.com/assets/img/ai-style-splatter_paint.webp'
  },
  {
    name: 'Line Art',
    value: 'minimal_line_art',
    imageUrl:
      'https://static.desygner.com/assets/img/ai-style-min_line_art.webp'
  }
];
